import PaymentDisbursementApprovalTable from './PaymentDisbursementApprovalTable';

export default PaymentDisbursementApprovalTable;
